import React from 'react';
import * as TrafftHelpRowStyle from "./trafftHelpRow.module.scss"
import SaveTime from "../../../images/homepage/trafftHelp/SaveTimeDark.svg";
import Boost from "../../../images/homepage/trafftHelp/BoostDark.svg";
import CustomerSatisfaction from "../../../images/homepage/trafftHelp/CustomerSatisfactionDark.svg";
import Increase from "../../../images/homepage/trafftHelp/IncreaseDark.svg";
import Carousel, {CarouselItem} from "../../common/carousel/carousel";
import usePageLoaded from "../../../context/usePageLoaded";
import {useWindowSize} from "../../../context/mediaQueryContext";

function TrafftHelpRow() {
  const {width} = useWindowSize();
  let cardInformation = [
    {
      icon: SaveTime,
      title: 'Save time',
      description: 'Leave pen-and-paper bookings in the past. Online appointment scheduling saves you hours every day, allowing you to focus more on your business or simply enjoy your newfound free time.'
    },
    {
      icon: Boost,
      title: 'Boost productivity',
      description: 'Spend less time on organization and have a fully-functional business. With an optimized scheduling process, you and your team have more time to dedicate to providing the best customer service.'
    },
    {
      icon: CustomerSatisfaction,
      title: 'Increase revenue',
      description: 'Trafft keeps your business available for booking 24/7 and boosts sales. Your customers can see your booking website and available hours and easily book at their convenience, or you can send them a booking link directly with all the booking information.'
    },
    {
      icon: Increase,
      title: 'Improve customer satisfaction',
      description: 'Trafft scheduling software for service industries allows your customers to book appointments online whenever suits them best. Offer an exceptional booking experience and gain loyal customers.'
    }
  ]
  const isPageLoaded = usePageLoaded()
  return (
    <div className={TrafftHelpRowStyle.trafftHelpRow}>
      {width < 1025 && isPageLoaded ?
        <Carousel>
          {cardInformation.map((item) =>
            <CarouselItem key={item.title}>
              <div className={TrafftHelpRowStyle.trafftHelpRow__card}>
                <img src={item.icon} alt=""/>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </CarouselItem>
          )}
        </Carousel>
        :
        cardInformation.map((item) =>
            <div className={TrafftHelpRowStyle.trafftHelpRow__card} key={item.title}>
              <img src={item.icon} alt=""/>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
        )
      }
    </div>
  );
}

export default TrafftHelpRow;